// extracted by mini-css-extract-plugin
export default {"root":"UsersTable_root__JEZrF","row":"UsersTable_row__V-o53","boxMargin":"UsersTable_boxMargin__jVbj7","fullHeight":"UsersTable_fullHeight__ZxQg9"};